<template>
  <div class="quote-modal">
    <button class="modal-close-button" @click="closeModal">X</button>
    <div class="quote-form">
      <div class="quote-left">
        <form @submit.prevent="submitForm" v-if="!formSubmitted">
          <h1>Request a Free Sample and Quote for your tray</h1><br />
          <input type="text" v-model="formData.name" placeholder="Full Name" required />
          <input type="text" v-model="formData.company" placeholder="Company" required />
          <input type="email" v-model="formData.email" placeholder="Email Address" required />
          <input type="tel" v-model="formData.phone" placeholder="Phone Number" required />
          <input type="number" v-model="formData.postal" placeholder="Postal Code" required />
          <input type="text" v-model="formData.country" placeholder="Country" required />
          <input type="number" v-model="formData.quantity" placeholder="Quantity" required min="1" />
          <br />
          <button type="submit" class="quoteButton" :disabled="isSubmitting">
            {{ isSubmitting ? 'Sending...' : 'Request a Free Sample and Quote' }}
          </button>
        </form>
        <div v-if="formSubmitted">
          <p :class="{'success-message': submissionSuccess, 'error-message': !submissionSuccess}">
            {{ submissionMessage }}
          </p>
        </div>
      </div>
      <div class="quote-right" id="tray-container" v-if="!formSubmitted">
        <img :src="trayImageUrl" alt="Tray Preview" v-if="trayImageUrl" width="100%" />
      </div>
      <div class="cleaner"></div>
    </div>
  </div>
</template>

<script>
import emailjs from '@emailjs/browser';

export default {
  props: ['trayImageUrl', 'trayName', 'traySize', 'productCode'],
  mounted() {
    emailjs.init('p60i6b7rnE2_kRckK');
  },
  data() {
    return {
      formData: {
        name: '',
        company: '',
        email: '',
        phone: '',
        postal: '',
        country: '',
        quantity: null,
      },
      submissionMessage: '',
      submissionSuccess: false,
      formSubmitted: false,
      isSubmitting: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
      this.formSubmitted = false;
      this.submissionMessage = '';
      this.submissionSuccess = false;
    },

    async uploadTrayImage() {
      try {
        if (!this.trayImageUrl) {
          return '';
        }

        // Convert data URL to blob
        const response = await fetch(this.trayImageUrl);
        const blob = await response.blob();
        
        // Create FormData
        const formData = new FormData();
        formData.append('file', blob, `tray-design-${Date.now()}.png`);
        
        // Upload to your server
        const uploadResponse = await fetch('https://appscambro.com/tray-personalization/upload', {
          method: 'POST',
          body: formData,
        });
        
        if (uploadResponse.ok) {
          const result = await uploadResponse.json();
          console.log('Image uploaded successfully:', result.url);
          return result.url;
        } else {
          console.error('Upload failed:', uploadResponse.status);
          return '';
        }
      } catch (error) {
        console.error('Error uploading image:', error);
        return '';
      }
    },
    
    resizeImage(dataUrl, maxWidth = 500, quality = 0.65) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Calculate new dimensions
          const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;
          
          // Draw resized image
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          
          // Convert to compressed data URL
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = dataUrl;
      });
    },

    async submitForm() {
      this.isSubmitting = true;
      
      let optimizedImage = this.trayImageUrl;
      if (this.trayImageUrl) {
        optimizedImage = await this.resizeImage(this.trayImageUrl, 800, 0.7);
      }
      
      try {
        const templateParams = {
          name: this.formData.name,
          company: this.formData.company,
          email: this.formData.email,
          phone: this.formData.phone,
          postal: this.formData.postal,
          country: this.formData.country,
          quantity: this.formData.quantity,
          trayName: this.trayName || 'Not specified',
          traySize: this.traySize || 'Not specified',
          productCode: this.productCode || 'Not specified',
          trayImageUrl: optimizedImage || 'No image available',
        };
    
        const response = await emailjs.send(
          'service_7gy8a6k',
          'template_l2126w5', 
          templateParams,
          'p60i6b7rnE2_kRckK'
        );
    
        this.submissionSuccess = true;
        this.submissionMessage = 'Your request has been received!';
        this.formSubmitted = true;
        
      } catch (error) {
        console.error('Error:', error);
        this.submissionSuccess = false;
        this.submissionMessage = 'Failed to send request. Please try again.';
        this.formSubmitted = true;
      } finally {
        this.isSubmitting = false;
      }
    }
  }
}
</script>